import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const CustomPush = ({ height = 48, width = 48, ...props }: SvgIconProps) => (
  <SvgIcon
    height={height}
    width={width}
    data-test="custom-push-illustration"
    viewBox="0 0 48 48"
    {...props}
  >
    <g clipPath="url(#clip0_4174_280634)">
      <path d="M27.7412 4.56912H35.8873V19.5034H27.7412V4.56912Z" fill="white" />
      <path
        d="M27.7412 4.56912H35.8873V19.5034H27.7412V4.56912Z"
        stroke="#020064"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M27.7412 7.28448H35.8873V16.1093H27.7412V7.28448Z" fill="#B0D9FF" />
      <path
        d="M27.7412 7.28448H35.8873V16.1093H27.7412V7.28448Z"
        stroke="#020064"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.1353 5.92703H32.4932"
        stroke="#020064"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.2581 17.8066C31.2581 17.954 31.3166 18.0954 31.4209 18.1996C31.5251 18.3038 31.6665 18.3624 31.8139 18.3624C31.9613 18.3624 32.1027 18.3038 32.2069 18.1996C32.3112 18.0954 32.3697 17.954 32.3697 17.8066C32.3697 17.6591 32.3112 17.5178 32.2069 17.4135C32.1027 17.3093 31.9613 17.2507 31.8139 17.2507C31.6665 17.2507 31.5251 17.3093 31.4209 17.4135C31.3166 17.5178 31.2581 17.6591 31.2581 17.8066Z"
        fill="#020064"
      />
      <path
        d="M29.9951 11.6434C29.9952 11.4806 29.9632 11.3194 29.9009 11.1689C29.8386 11.0185 29.7474 10.8818 29.6323 10.7667C29.5172 10.6516 29.3805 10.5602 29.2301 10.4979C29.0797 10.4356 28.9185 10.4035 28.7557 10.4035H13.2623C13.0995 10.4035 12.9383 10.4356 12.7879 10.4979C12.6375 10.5602 12.5009 10.6516 12.3858 10.7667C12.2707 10.8818 12.1794 11.0185 12.1172 11.1689C12.0549 11.3194 12.0229 11.4806 12.0229 11.6434V20.939H29.9951V11.6434Z"
        fill="white"
        stroke="#020064"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.1362 20.939H13.8826V12.5213C13.8825 12.4874 13.8891 12.4537 13.9021 12.4224C13.9151 12.391 13.9341 12.3625 13.9581 12.3385C13.9821 12.3145 14.0105 12.2955 14.0419 12.2826C14.0733 12.2696 14.1069 12.263 14.1408 12.263H27.8779C27.9464 12.263 28.0121 12.2903 28.0605 12.3387C28.109 12.3871 28.1362 12.4528 28.1362 12.5213V20.939Z"
        fill="#B0D9FF"
      />
      <path
        d="M27.7281 23.4178H14.2881C13.6717 23.4193 13.0648 23.2664 12.5227 22.9729C11.9807 22.6794 11.5209 22.2548 11.1853 21.7378C11.1342 21.6599 11.1051 21.5697 11.1011 21.4767C11.0971 21.3836 11.1184 21.2912 11.1627 21.2093C11.207 21.1274 11.2726 21.059 11.3527 21.0114C11.4328 20.9638 11.5242 20.9388 11.6173 20.939H30.3988C30.4919 20.9391 30.5832 20.9643 30.6631 21.012C30.7431 21.0596 30.8086 21.128 30.8529 21.2099C30.8972 21.2918 30.9185 21.3841 30.9146 21.4771C30.9107 21.5701 30.8817 21.6603 30.8308 21.7382C30.4951 22.2552 30.0353 22.6797 29.4933 22.9731C28.9513 23.2665 28.3444 23.4194 27.7281 23.4178Z"
        fill="white"
      />
      <path
        d="M27.7281 23.4178H14.2881C13.6717 23.4193 13.0648 23.2664 12.5227 22.9729C11.9807 22.6794 11.5209 22.2548 11.1853 21.7378C11.1342 21.6599 11.1051 21.5697 11.1011 21.4767C11.0971 21.3836 11.1184 21.2912 11.1627 21.2093C11.207 21.1274 11.2726 21.059 11.3527 21.0114C11.4328 20.9638 11.5242 20.9388 11.6173 20.939H30.3988C30.4919 20.9391 30.5832 20.9643 30.6631 21.012C30.7431 21.0596 30.8086 21.128 30.8529 21.2099C30.8972 21.2918 30.9185 21.3841 30.9146 21.4771C30.9107 21.5701 30.8817 21.6603 30.8308 21.7382C30.4951 22.2552 30.0353 22.6797 29.4933 22.9731C28.9513 23.2665 28.3444 23.4194 27.7281 23.4178Z"
        stroke="#020064"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.1362 20.939H13.8826V12.5213C13.8825 12.4874 13.8891 12.4537 13.9021 12.4224C13.9151 12.391 13.9341 12.3625 13.9581 12.3385C13.9821 12.3145 14.0105 12.2955 14.0419 12.2826C14.0733 12.2696 14.1069 12.263 14.1408 12.263H27.8779C27.9464 12.263 28.0121 12.2903 28.0605 12.3387C28.109 12.3871 28.1362 12.4528 28.1362 12.5213V20.939Z"
        stroke="#020064"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2911 22.1784H16.3613"
        stroke="#020064"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1219 22.1784H13.8826"
        stroke="#020064"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12.7627 36.444H16.3613V38.603H12.7627V36.444Z" fill="white" />
      <path
        d="M12.7627 36.444H16.3613V38.603H12.7627V36.444Z"
        stroke="#020064"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.24 40.0421H9.88428C9.88428 39.6602 10.036 39.2939 10.306 39.0239C10.5761 38.7538 10.9424 38.6021 11.3243 38.6021H17.8004C18.1823 38.6022 18.5484 38.754 18.8184 39.024C19.0883 39.2941 19.24 39.6603 19.24 40.0421Z"
        fill="white"
        stroke="#020064"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9179 19.8912H5.20604C4.72911 19.8916 4.27184 20.0813 3.93469 20.4186C3.59754 20.7559 3.40809 21.2133 3.40796 21.6902V33.565H25.7184V21.6902C25.7184 21.4539 25.6718 21.2198 25.5813 21.0015C25.4908 20.7831 25.3581 20.5847 25.1909 20.4176C25.0237 20.2505 24.8252 20.1181 24.6068 20.0277C24.3883 19.9374 24.1543 19.891 23.9179 19.8912Z"
        fill="#B0D9FF"
      />
      <path
        d="M23.9179 19.8912H5.20604C4.72911 19.8916 4.27184 20.0813 3.93469 20.4186C3.59754 20.7559 3.40809 21.2133 3.40796 21.6902V33.565H25.7184V21.6902C25.7184 21.4539 25.6718 21.2198 25.5813 21.0015C25.4908 20.7831 25.3581 20.5847 25.1909 20.4176C25.0237 20.2505 24.8252 20.1181 24.6068 20.0277C24.3883 19.9374 24.1543 19.891 23.9179 19.8912Z"
        stroke="#020064"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9179 36.444C24.1542 36.444 24.3882 36.3974 24.6065 36.307C24.8248 36.2166 25.0231 36.084 25.1902 35.9169C25.3572 35.7498 25.4897 35.5514 25.5801 35.3331C25.6705 35.1148 25.717 34.8808 25.7169 34.6445V33.565H3.40796V34.6445C3.4079 34.8808 3.45438 35.1148 3.54477 35.3331C3.63515 35.5514 3.76765 35.7498 3.93472 35.9169C4.10178 36.084 4.30012 36.2166 4.51843 36.307C4.73673 36.3974 4.97071 36.444 5.207 36.444H23.9179Z"
        fill="white"
        stroke="#020064"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.7417 24.2309C3.7417 29.323 5.76455 34.2066 9.36525 37.8073C12.9659 41.408 17.8495 43.4309 22.9417 43.4309C28.0339 43.4309 32.9174 41.408 36.5181 37.8073C40.1188 34.2066 42.1417 29.323 42.1417 24.2309C42.1417 19.1387 40.1188 14.2551 36.5181 10.6544C32.9174 7.05374 28.0339 5.03088 22.9417 5.03088C17.8495 5.03088 12.9659 7.05374 9.36525 10.6544C5.76455 14.2551 3.7417 19.1387 3.7417 24.2309Z"
        fill="#E6FBFF"
      />
      <path d="M27.7412 4.56912H35.8873V19.5034H27.7412V4.56912Z" fill="white" />
      <path
        d="M27.7412 4.56912H35.8873V19.5034H27.7412V4.56912Z"
        stroke="#0B3251"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M27.7412 7.28448H35.8873V16.1093H27.7412V7.28448Z" fill="#C2F0FC" />
      <path
        d="M27.7412 7.28448H35.8873V16.1093H27.7412V7.28448Z"
        stroke="#0B3251"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.1353 5.92703H32.4932"
        stroke="#0B3251"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.2581 17.8066C31.2581 17.954 31.3166 18.0954 31.4209 18.1996C31.5251 18.3038 31.6665 18.3624 31.8139 18.3624C31.9613 18.3624 32.1027 18.3038 32.2069 18.1996C32.3112 18.0954 32.3697 17.954 32.3697 17.8066C32.3697 17.6591 32.3112 17.5178 32.2069 17.4135C32.1027 17.3093 31.9613 17.2507 31.8139 17.2507C31.6665 17.2507 31.5251 17.3093 31.4209 17.4135C31.3166 17.5178 31.2581 17.6591 31.2581 17.8066Z"
        fill="#0B3251"
      />
      <path
        d="M29.9951 11.6434C29.9952 11.4806 29.9632 11.3194 29.9009 11.1689C29.8386 11.0185 29.7474 10.8818 29.6323 10.7667C29.5172 10.6516 29.3805 10.5602 29.2301 10.4979C29.0797 10.4356 28.9185 10.4035 28.7557 10.4035H13.2623C13.0995 10.4035 12.9383 10.4356 12.7879 10.4979C12.6375 10.5602 12.5009 10.6516 12.3858 10.7667C12.2707 10.8818 12.1794 11.0185 12.1172 11.1689C12.0549 11.3194 12.0229 11.4806 12.0229 11.6434V20.939H29.9951V11.6434Z"
        fill="white"
        stroke="#0B3251"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.1362 20.939H13.8826V12.5213C13.8825 12.4874 13.8891 12.4537 13.9021 12.4224C13.9151 12.391 13.9341 12.3625 13.9581 12.3385C13.9821 12.3145 14.0105 12.2955 14.0419 12.2826C14.0733 12.2696 14.1069 12.263 14.1408 12.263H27.8779C27.9464 12.263 28.0121 12.2903 28.0605 12.3387C28.109 12.3871 28.1362 12.4528 28.1362 12.5213V20.939Z"
        fill="#C2F0FC"
      />
      <path
        d="M27.7281 23.4178H14.2881C13.6717 23.4193 13.0648 23.2664 12.5227 22.9729C11.9807 22.6794 11.5209 22.2548 11.1853 21.7378C11.1342 21.6599 11.1051 21.5697 11.1011 21.4767C11.0971 21.3836 11.1184 21.2912 11.1627 21.2093C11.207 21.1274 11.2726 21.059 11.3527 21.0114C11.4328 20.9638 11.5242 20.9388 11.6173 20.939H30.3988C30.4919 20.9391 30.5832 20.9643 30.6631 21.012C30.7431 21.0596 30.8086 21.128 30.8529 21.2099C30.8972 21.2918 30.9185 21.3841 30.9146 21.4771C30.9107 21.5701 30.8817 21.6603 30.8308 21.7382C30.4951 22.2552 30.0353 22.6797 29.4933 22.9731C28.9513 23.2665 28.3444 23.4194 27.7281 23.4178Z"
        fill="white"
      />
      <path
        d="M27.7281 23.4178H14.2881C13.6717 23.4193 13.0648 23.2664 12.5227 22.9729C11.9807 22.6794 11.5209 22.2548 11.1853 21.7378C11.1342 21.6599 11.1051 21.5697 11.1011 21.4767C11.0971 21.3836 11.1184 21.2912 11.1627 21.2093C11.207 21.1274 11.2726 21.059 11.3527 21.0114C11.4328 20.9638 11.5242 20.9388 11.6173 20.939H30.3988C30.4919 20.9391 30.5832 20.9643 30.6631 21.012C30.7431 21.0596 30.8086 21.128 30.8529 21.2099C30.8972 21.2918 30.9185 21.3841 30.9146 21.4771C30.9107 21.5701 30.8817 21.6603 30.8308 21.7382C30.4951 22.2552 30.0353 22.6797 29.4933 22.9731C28.9513 23.2665 28.3444 23.4194 27.7281 23.4178Z"
        stroke="#0B3251"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.1362 20.939H13.8826V12.5213C13.8825 12.4874 13.8891 12.4537 13.9021 12.4224C13.9151 12.391 13.9341 12.3625 13.9581 12.3385C13.9821 12.3145 14.0105 12.2955 14.0419 12.2826C14.0733 12.2696 14.1069 12.263 14.1408 12.263H27.8779C27.9464 12.263 28.0121 12.2903 28.0605 12.3387C28.109 12.3871 28.1362 12.4528 28.1362 12.5213V20.939Z"
        stroke="#0B3251"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2911 22.1784H16.3613"
        stroke="#0B3251"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1219 22.1784H13.8826"
        stroke="#0B3251"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12.7627 36.444H16.3613V38.603H12.7627V36.444Z" fill="white" />
      <path
        d="M12.7627 36.444H16.3613V38.603H12.7627V36.444Z"
        stroke="#0B3251"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.24 40.0421H9.88428C9.88428 39.6602 10.036 39.2939 10.306 39.0239C10.5761 38.7538 10.9424 38.6021 11.3243 38.6021H17.8004C18.1823 38.6022 18.5484 38.754 18.8184 39.024C19.0883 39.2941 19.24 39.6603 19.24 40.0421Z"
        fill="white"
        stroke="#0B3251"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9179 19.8912H5.20604C4.72911 19.8916 4.27184 20.0813 3.93469 20.4186C3.59754 20.7559 3.40809 21.2133 3.40796 21.6902V33.565H25.7184V21.6902C25.7184 21.4539 25.6718 21.2198 25.5813 21.0015C25.4908 20.7831 25.3581 20.5847 25.1909 20.4176C25.0237 20.2505 24.8252 20.1181 24.6068 20.0277C24.3883 19.9374 24.1543 19.891 23.9179 19.8912Z"
        fill="#C2F0FC"
      />
      <path
        d="M23.9179 19.8912H5.20604C4.72911 19.8916 4.27184 20.0813 3.93469 20.4186C3.59754 20.7559 3.40809 21.2133 3.40796 21.6902V33.565H25.7184V21.6902C25.7184 21.4539 25.6718 21.2198 25.5813 21.0015C25.4908 20.7831 25.3581 20.5847 25.1909 20.4176C25.0237 20.2505 24.8252 20.1181 24.6068 20.0277C24.3883 19.9374 24.1543 19.891 23.9179 19.8912Z"
        stroke="#0B3251"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9179 36.4439C24.1542 36.4439 24.3882 36.3974 24.6065 36.3069C24.8248 36.2165 25.0231 36.0839 25.1902 35.9168C25.3572 35.7497 25.4897 35.5513 25.5801 35.333C25.6705 35.1147 25.717 34.8807 25.7169 34.6444V33.5649H3.40796V34.6444C3.4079 34.8807 3.45438 35.1147 3.54477 35.333C3.63515 35.5513 3.76765 35.7497 3.93472 35.9168C4.10178 36.0839 4.30012 36.2165 4.51843 36.3069C4.73673 36.3974 4.97071 36.4439 5.207 36.4439H23.9179Z"
        fill="white"
        stroke="#0B3251"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9622 35.0045C13.9622 35.0832 13.9777 35.1612 14.0078 35.2339C14.0379 35.3066 14.0821 35.3727 14.1378 35.4284C14.1934 35.4841 14.2595 35.5282 14.3323 35.5584C14.405 35.5885 14.4829 35.604 14.5617 35.604C14.6404 35.604 14.7184 35.5885 14.7911 35.5584C14.8638 35.5282 14.9299 35.4841 14.9856 35.4284C15.0413 35.3727 15.0854 35.3066 15.1156 35.2339C15.1457 35.1612 15.1612 35.0832 15.1612 35.0045C15.1612 34.9258 15.1457 34.8478 15.1156 34.7751C15.0854 34.7023 15.0413 34.6362 14.9856 34.5806C14.9299 34.5249 14.8638 34.4807 14.7911 34.4506C14.7184 34.4205 14.6404 34.405 14.5617 34.405C14.4829 34.405 14.405 34.4205 14.3323 34.4506C14.2595 34.4807 14.1934 34.5249 14.1378 34.5806C14.0821 34.6362 14.0379 34.7023 14.0078 34.7751C13.9777 34.8478 13.9622 34.9258 13.9622 35.0045Z"
        fill="#0B3251"
      />
      <path
        d="M27.6501 32.8968C27.5755 32.8726 27.5099 32.8267 27.4617 32.7649C27.4135 32.7031 27.385 32.6283 27.3798 32.5502C27.3746 32.472 27.393 32.3941 27.4325 32.3265C27.4721 32.2589 27.5311 32.2047 27.6018 32.1709L39.276 26.5858C39.3488 26.551 39.4305 26.5395 39.51 26.5528C39.5896 26.5661 39.6631 26.6035 39.7206 26.6601C39.778 26.7166 39.8167 26.7895 39.8312 26.8687C39.8457 26.948 39.8354 27.0298 39.8017 27.103L34.3921 38.8509C34.3595 38.9223 34.3062 38.9822 34.239 39.023C34.1719 39.0637 34.0941 39.0834 34.0157 39.0795C33.9373 39.0755 33.8618 39.0482 33.7991 39.001C33.7365 38.9537 33.6894 38.8888 33.6641 38.8145L32.2016 34.5385C32.182 34.4809 32.1491 34.4287 32.1057 34.386C32.0623 34.3433 32.0095 34.3113 31.9516 34.2925L27.6501 32.8968Z"
        fill="white"
        stroke="#0B3251"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.2023 34.5418L33.6647 38.8179C33.6901 38.892 33.7371 38.9568 33.7997 39.0039C33.8624 39.051 33.9377 39.0783 34.0159 39.0823C34.0942 39.0862 34.1719 39.0667 34.239 39.0261C34.306 38.9855 34.3594 38.9258 34.3921 38.8547L39.802 27.1056C39.8359 27.0323 39.8462 26.9504 39.8317 26.8711C39.8171 26.7917 39.7784 26.7188 39.7207 26.6623L32.1063 34.3892C32.1497 34.432 32.1825 34.4842 32.2023 34.5418Z"
        fill="white"
        stroke="#0B3251"
        strokeWidth="0.64"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4174_280634">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);
